import pink00000 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00000.webp";
import pink00001 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00001.webp";
import pink00002 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00002.webp";
import pink00003 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00003.webp";
import pink00004 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00004.webp";
import pink00005 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00005.webp";
import pink00006 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00006.webp";
import pink00007 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00007.webp";
import pink00008 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00008.webp";
import pink00009 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00009.webp";
import pink00010 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00010.webp";
import pink00011 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00011.webp";
import pink00012 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00012.webp";
import pink00013 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00013.webp";
import pink00014 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00014.webp";
import pink00015 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00015.webp";
import pink00016 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00016.webp";
import pink00017 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00017.webp";
import pink00018 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00018.webp";
import pink00019 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00019.webp";
import pink00020 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00020.webp";
import pink00021 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00021.webp";
import pink00022 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00022.webp";
import pink00023 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00023.webp";
import pink00024 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00024.webp";
import pink00025 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00025.webp";
import pink00026 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00026.webp";
import pink00027 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00027.webp";
import pink00028 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00028.webp";
import pink00029 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00029.webp";
import pink00030 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00030.webp";
import pink00031 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00031.webp";
import pink00032 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00032.webp";
import pink00033 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00033.webp";
import pink00034 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00034.webp";
import pink00035 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00035.webp";
import pink00036 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00036.webp";
import pink00037 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00037.webp";
import pink00038 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00038.webp";
import pink00039 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00039.webp";
import pink00040 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00040.webp";
import pink00041 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00041.webp";
import pink00042 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00042.webp";
import pink00043 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00043.webp";
import pink00044 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00044.webp";
import pink00045 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00045.webp";
import pink00046 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00046.webp";
import pink00047 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00047.webp";
import pink00048 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00048.webp";
import pink00049 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00049.webp";
import pink00050 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00050.webp";
import pink00051 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00051.webp";
import pink00052 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00052.webp";
import pink00053 from "../../assets/images/bearSelection/bear_rotate_webp pink/bear rotate_00053.webp";

import yellow00000 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00000.webp";
import yellow00001 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00001.webp";
import yellow00002 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00002.webp";
import yellow00003 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00003.webp";
import yellow00004 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00004.webp";
import yellow00005 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00005.webp";
import yellow00006 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00006.webp";
import yellow00007 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00007.webp";
import yellow00008 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00008.webp";
import yellow00009 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00009.webp";
import yellow00010 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00010.webp";
import yellow00011 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00011.webp";
import yellow00012 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00012.webp";
import yellow00013 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00013.webp";
import yellow00014 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00014.webp";
import yellow00015 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00015.webp";
import yellow00016 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00016.webp";
import yellow00017 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00017.webp";
import yellow00018 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00018.webp";
import yellow00019 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00019.webp";
import yellow00020 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00020.webp";
import yellow00021 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00021.webp";
import yellow00022 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00022.webp";
import yellow00023 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00023.webp";
import yellow00024 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00024.webp";
import yellow00025 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00025.webp";
import yellow00026 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00026.webp";
import yellow00027 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00027.webp";
import yellow00028 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00028.webp";
import yellow00029 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00029.webp";
import yellow00030 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00030.webp";
import yellow00031 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00031.webp";
import yellow00032 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00032.webp";
import yellow00033 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00033.webp";
import yellow00034 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00034.webp";
import yellow00035 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00035.webp";
import yellow00036 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00036.webp";
import yellow00037 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00037.webp";
import yellow00038 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00038.webp";
import yellow00039 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00039.webp";
import yellow00040 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00040.webp";
import yellow00041 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00041.webp";
import yellow00042 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00042.webp";
import yellow00043 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00043.webp";
import yellow00044 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00044.webp";
import yellow00045 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00045.webp";
import yellow00046 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00046.webp";
import yellow00047 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00047.webp";
import yellow00048 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00048.webp";
import yellow00049 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00049.webp";
import yellow00050 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00050.webp";
import yellow00051 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00051.webp";
import yellow00052 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00052.webp";
import yellow00053 from "../../assets/images/bearSelection/bear_rotate_webp yellow/bear rotate_00053.webp";

import blue00000 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00000.webp";
import blue00001 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00001.webp";
import blue00002 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00002.webp";
import blue00003 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00003.webp";
import blue00004 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00004.webp";
import blue00005 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00005.webp";
import blue00006 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00006.webp";
import blue00007 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00007.webp";
import blue00008 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00008.webp";
import blue00009 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00009.webp";
import blue00010 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00010.webp";
import blue00011 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00011.webp";
import blue00012 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00012.webp";
import blue00013 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00013.webp";
import blue00014 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00014.webp";
import blue00015 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00015.webp";
import blue00016 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00016.webp";
import blue00017 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00017.webp";
import blue00018 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00018.webp";
import blue00019 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00019.webp";
import blue00020 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00020.webp";
import blue00021 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00021.webp";
import blue00022 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00022.webp";
import blue00023 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00023.webp";
import blue00024 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00024.webp";
import blue00025 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00025.webp";
import blue00026 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00026.webp";
import blue00027 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00027.webp";
import blue00028 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00028.webp";
import blue00029 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00029.webp";
import blue00030 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00030.webp";
import blue00031 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00031.webp";
import blue00032 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00032.webp";
import blue00033 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00033.webp";
import blue00034 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00034.webp";
import blue00035 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00035.webp";
import blue00036 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00036.webp";
import blue00037 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00037.webp";
import blue00038 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00038.webp";
import blue00039 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00039.webp";
import blue00040 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00040.webp";
import blue00041 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00041.webp";
import blue00042 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00042.webp";
import blue00043 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00043.webp";
import blue00044 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00044.webp";
import blue00045 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00045.webp";
import blue00046 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00046.webp";
import blue00047 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00047.webp";
import blue00048 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00048.webp";
import blue00049 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00049.webp";
import blue00050 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00050.webp";
import blue00051 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00051.webp";
import blue00052 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00052.webp";
import blue00053 from "../../assets/images/bearSelection/bear_rotate_webp blue/bear rotate_00053.webp";

import green00000 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00000.webp";
import green00001 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00001.webp";
import green00002 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00002.webp";
import green00003 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00003.webp";
import green00004 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00004.webp";
import green00005 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00005.webp";
import green00006 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00006.webp";
import green00007 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00007.webp";
import green00008 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00008.webp";
import green00009 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00009.webp";
import green00010 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00010.webp";
import green00011 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00011.webp";
import green00012 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00012.webp";
import green00013 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00013.webp";
import green00014 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00014.webp";
import green00015 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00015.webp";
import green00016 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00016.webp";
import green00017 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00017.webp";
import green00018 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00018.webp";
import green00019 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00019.webp";
import green00020 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00020.webp";
import green00021 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00021.webp";
import green00022 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00022.webp";
import green00023 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00023.webp";
import green00024 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00024.webp";
import green00025 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00025.webp";
import green00026 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00026.webp";
import green00027 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00027.webp";
import green00028 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00028.webp";
import green00029 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00029.webp";
import green00030 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00030.webp";
import green00031 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00031.webp";
import green00032 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00032.webp";
import green00033 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00033.webp";
import green00034 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00034.webp";
import green00035 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00035.webp";
import green00036 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00036.webp";
import green00037 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00037.webp";
import green00038 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00038.webp";
import green00039 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00039.webp";
import green00040 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00040.webp";
import green00041 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00041.webp";
import green00042 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00042.webp";
import green00043 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00043.webp";
import green00044 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00044.webp";
import green00045 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00045.webp";
import green00046 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00046.webp";
import green00047 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00047.webp";
import green00048 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00048.webp";
import green00049 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00049.webp";
import green00050 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00050.webp";
import green00051 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00051.webp";
import green00052 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00052.webp";
import green00053 from "../../assets/images/bearSelection/bear_rotate_webp green/bear rotate_00053.webp";

const bearPink = [
  pink00000,
  pink00001,
  pink00002,
  pink00003,
  pink00004,
  pink00005,
  pink00006,
  pink00007,
  pink00008,
  pink00009,
  pink00010,
  pink00011,
  pink00012,
  pink00013,
  pink00014,
  pink00015,
  pink00016,
  pink00017,
  pink00018,
  pink00019,
  pink00020,
  pink00021,
  pink00022,
  pink00023,
  pink00024,
  pink00025,
  pink00026,
  pink00027,
  pink00028,
  pink00029,
  pink00030,
  pink00031,
  pink00032,
  pink00033,
  pink00034,
  pink00035,
  pink00036,
  pink00037,
  pink00038,
  pink00039,
  pink00040,
  pink00041,
  pink00042,
  pink00043,
  pink00044,
  pink00045,
  pink00046,
  pink00047,
  pink00048,
  pink00049,
  pink00050,
  pink00051,
  pink00052,
  pink00053,
];

const bearYellow = [
  yellow00000,
  yellow00001,
  yellow00002,
  yellow00003,
  yellow00004,
  yellow00005,
  yellow00006,
  yellow00007,
  yellow00008,
  yellow00009,
  yellow00010,
  yellow00011,
  yellow00012,
  yellow00013,
  yellow00014,
  yellow00015,
  yellow00016,
  yellow00017,
  yellow00018,
  yellow00019,
  yellow00020,
  yellow00021,
  yellow00022,
  yellow00023,
  yellow00024,
  yellow00025,
  yellow00026,
  yellow00027,
  yellow00028,
  yellow00029,
  yellow00030,
  yellow00031,
  yellow00032,
  yellow00033,
  yellow00034,
  yellow00035,
  yellow00036,
  yellow00037,
  yellow00038,
  yellow00039,
  yellow00040,
  yellow00041,
  yellow00042,
  yellow00043,
  yellow00044,
  yellow00045,
  yellow00046,
  yellow00047,
  yellow00048,
  yellow00049,
  yellow00050,
  yellow00051,
  yellow00052,
  yellow00053,
];

const bearBlue = [
  blue00000,
  blue00001,
  blue00002,
  blue00003,
  blue00004,
  blue00005,
  blue00006,
  blue00007,
  blue00008,
  blue00009,
  blue00010,
  blue00011,
  blue00012,
  blue00013,
  blue00014,
  blue00015,
  blue00016,
  blue00017,
  blue00018,
  blue00019,
  blue00020,
  blue00021,
  blue00022,
  blue00023,
  blue00024,
  blue00025,
  blue00026,
  blue00027,
  blue00028,
  blue00029,
  blue00030,
  blue00031,
  blue00032,
  blue00033,
  blue00034,
  blue00035,
  blue00036,
  blue00037,
  blue00038,
  blue00039,
  blue00040,
  blue00041,
  blue00042,
  blue00043,
  blue00044,
  blue00045,
  blue00046,
  blue00047,
  blue00048,
  blue00049,
  blue00050,
  blue00051,
  blue00052,
  blue00053,
];

const bearGreen = [
  green00000,
  green00001,
  green00002,
  green00003,
  green00004,
  green00005,
  green00006,
  green00007,
  green00008,
  green00009,
  green00010,
  green00011,
  green00012,
  green00013,
  green00014,
  green00015,
  green00016,
  green00017,
  green00018,
  green00019,
  green00020,
  green00021,
  green00022,
  green00023,
  green00024,
  green00025,
  green00026,
  green00027,
  green00028,
  green00029,
  green00030,
  green00031,
  green00032,
  green00033,
  green00034,
  green00035,
  green00036,
  green00037,
  green00038,
  green00039,
  green00040,
  green00041,
  green00042,
  green00043,
  green00044,
  green00045,
  green00046,
  green00047,
  green00048,
  green00049,
  green00050,
  green00051,
  green00052,
  green00053,
];

const images = { bearPink, bearYellow, bearBlue, bearGreen };

export default images;
